// PUBLIC
export enum BooleanInt {
    False = 0,
    True = 1,
}

export enum RepeatIssue {
    None = 0,
    RepeatedUnconfirmed = 1,
    Repeated = 2
}


export enum Mode {
    Create = 0,
    Update = 1,
    View = 2,
}

export enum Status {
    Deleted = -9,
    Blocked = -2,
    Cancel = -3,
    Reject = -4,
    Draft = -1,
    Inactive = 0,
    Active = 1,
}

export enum ActionRequest {
    Create = 0,
    Update = 1,
    Delete = -1,
    Empty = -2,
    Detail = -33,
}

export enum AvailableLanguage {
    Vietnamese = "vi",
    English = "en",
}

export enum PL {
    PLIV = "PLIV",
    PLIII = "PLIII",
}

export enum ReportStatus {
    new = "0",
    analyzed = "1",
    processing = "2",
    processed = "3",
    cancelled = "4",
    closed = "5",
}

export enum ReportDocumentType {
    ImgReport = 0,
    ImgAnalyze = 1,
    ImgFishboneDiagram = 2,
    PdfReport = 2,
}

export enum GeographySource {
    Origin = 1,
    Expedia = 2,
}

export enum GeographyType {
    AdministrativeDivision = 32768, // Hệ thống hành chính
    Area = 16384, // Các vùng dân cư
    TransportHub = 8192, // Các dịch vụ công cộng
    Other = 4096, // Các loại khác

    // Bộ other
    PointOfInterest = 1,

    // TransportHub
    BusStation = 2,
    MetroStation = 4,
    TrainStation = 8,
    Airport = 16,

    // Area
    Neighborhood = 32,
    MultiCityVicinity = 64,
    HighLevelRegion = 128,

    // AdministrativeDivision
    City = 256,
    ProvinceState = 512,
    Country = 1024,
    Continet = 2048,
}

export enum MessageRequestType {
    Absence = 0,
    ReportWork = 1,
    Invitation = 2,
    ForgotPassWord = 3,
    ResetPass = 4,
    Course = 5,
    Post = 6,
    Booking = 7,
    Other = 9,

    // MIRS
    MirsAnalysis = 10,
    MirsIncident = 11,
}

export enum AllGroupCodeName {
    // userRole = "userRole",
    incidentObject = "incidentObject",
    reportType = "reportType",
    level = "level",
    classtify = "classtify",
    gender = "gender",
    reportStatus = "reportStatus",
    common = "common",
    technicalProcessCaused = "technicalProcessCaused",
    infectionCaused = "infectionCaused",
    medicineCaused = "medicineCaused",
    bloodProductCaused = "bloodProductCaused",
    medicalEquipmentCaused = "medicalEquipmentCaused",
    misbehaveCaused = "misbehaveCaused",
    patientIncidentCaused = "patientIncidentCaused",
    infrastructureCaused = "infrastructureCaused",
    managementCaused = "managementCaused",
    procedureCaused = "procedureCaused",
    // otherGroupCaused = "otherGroupCaused",
    staffCaused = "staffCaused",
    patientCaused = "patientCaused",
    environmentCaused = "environmentCaused",
    serviceCaused = "serviceCaused",
    externalFactorCaused = "externalFactorCaused",
    // otherFactorCaused = "otherFactorCaused",
    affectedToOrganization = "affectedToOrganization",
    affectedToPatient = "affectedToPatient",
    staffTitle = "staffTitle",
    incidentType = "incidentType",
    causeGroup = "causeGroup",
    levelReport = "levelReport",
    affectedToPatientCause = "affectedToPatientCause",
    managementPatient = "managementPatient",
    equipment = "equipment",
    environmentPatient = "environmentPatient",
    medical = "medical",
    surgery = "surgery",
    crime = "crime",
    byHospital = "byHospital",
    byHospitalSource = "byHospitalSource",
    organizationType = "organizationType",
}

export enum IncidentReportTemplate
{
    Default = 1,    // Maysoft
    SoYTe = 2       // Sở Y Tế
}